<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="1 2 340 550" style="enable-background:new 0 0 350 550;" xml:space="preserve">
        <defs>
	<filter id="Adobe_OpacityMaskFilter" filterUnits="userSpaceOnUse" x="0" y="0" width="350" height="550">
		<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
	</filter>
</defs>
        <g id="Cacharel_x5F_FW23-24_x5F_LB_x5F_0001106_xA0_Image_00000164476013882364385290000014175750859365193625_" style="mask:url(#Cacharel_x5F_FW23-24_x5F_LB_x5F_0001106_xA0_Image_00000168075017096489388340000002944832889775888768_);">

		<image style="overflow:visible;" width="350" height="550" id="Cacharel_x5F_FW23-24_x5F_LB_x5F_0001106_xA0_Image"
               xlink:href="https://static.supsis.live/common/aydinli/assets/CacharelAlert.svg">
	</image>
</g>
</svg>

</template>
<script>
export default {
    name: "Cacharel",
};
</script>
<style type="text/css">
.st0{filter:url(#Adobe_OpacityMaskFilter);}
.st1{mask:url(#Cacharel_x5F_FW23-24_x5F_LB_x5F_0001106_xA0_Image_00000000932089762431875310000011277901225358371249_);}
</style>



// WEBPACK FOOTER //
// src/components/V2/uspaV2/asset/Cacharel.vue